import React from 'react';
import Carousel from './Carousel';
import AboutSection from '../pages/AboutSection';
import ServicesSection from '../pages/ServicesSection';
import WhyChooseOne from '../pages/WhyChooseOne';
import TaxiRates from '../pages/TaxiRates';
import DownloadAppAmruta from '../pages/DownloadAppAmruta';
import Testimonials from '../pages/Testimonials';
// import BlogOne from '../pages/BlogOne';



const HeroSection = () => {
  
  return (


    <div className="th-hero-wrapper hero-1" id="hero">



 <Carousel/>
<AboutSection/>
<ServicesSection/>
<WhyChooseOne/>
<TaxiRates/>
<Testimonials/>
<DownloadAppAmruta/>

{/* <BlogOne/> */}
    </div>
  );
};

export default HeroSection;
